<template>
  <FormKit type="form" autocomplete="off" :actions="false">
    <section class="max-w-[300px] w-full py-4 md:max-w-none overflow-x-scroll">
      <table class="table-fixed min-w-[720px] border-collapse">
        <thead>
          <tr>
            <th
              class="ring-1 ring-inset px-2 py-2 text-sm font-medium ring-black/20 dark:ring-white/20 min-w-[80px]"
              v-for="field in context.fields"
              v-text="field.title"
            />
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, i) in model">
            <td :key="`${field.id}-${i}`" v-for="field in context.fields">
              <FormKit
                v-model="model[i][field.id]"
                :classes="{
                  outer: '!m-0 rounded-none h-full',
                  inner: '!m-0 rounded-none h-full py-1',
                  wrapper: 'h-full',
                  input: 'text-sm text-center',
                }"
                type="text"
                autocomplete="off"
                :placeholder="field.placeholder"
              />
            </td>
            <td>
              <UIButton
                v-if="i !== 0"
                class="ml-3 h-8 w-8"
                :icon="IconTrash"
                size="sm"
                type="danger"
                @click="removeRecord(i)"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="w-full mt-4 pr-[3rem]">
        <UIButton
          size="sm"
          @click="addRecord"
          type="gray"
          class="w-full"
          title="Добавить строку"
          :icon="IconPlus"
        />
      </div>
    </section>
  </FormKit>
</template>

<script setup>
import { computed, onMounted } from 'vue'

import { IconPlus, IconTrash } from '@tabler/icons-vue'

import UIButton from '@/components/ui/UIButton.vue'

const props = defineProps({
  modelValue: {
    type: [Array],
    default: [{}],
  },
  context: {
    type: Object,
  },
  type: {
    type: Object,
  },
  passed: {
    type: Boolean,
  },
})

const emits = defineEmits(['passed', 'update:model-value'])

const model = computed({
  get: () => {
    return props.modelValue ?? [{}]
  },
  set: (val) => {
    emits('update:model-value', val)
  },
})

function addRecord() {
  model.value = [...model.value, {}]
}

function removeRecord(i) {
  model.value.splice(i, 1)
}

onMounted(() => {
  emits('update:model-value', model.value)
})
</script>
